import ReactIcon from './IconBase';
import { normalizeTwoToneColors } from '../utils';
export function setTwoToneColor(twoToneColor) {
    var _a = normalizeTwoToneColors(twoToneColor), primaryColor = _a[0], secondaryColor = _a[1];
    return ReactIcon.setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
export function getTwoToneColor() {
    var colors = ReactIcon.getTwoToneColors();
    if (!colors.calculated) {
        return colors.primaryColor;
    }
    /*
     *  temporary disable this rule for build
     */
    // @ts-ignore
    return [colors.primaryColor, colors.secondaryColor];
}
